import {
  FiHome,
  FiPackage,
  FiShoppingBag,
  FiUser,
  FiTrendingUp,
  FiBox,
  FiStar,
  FiBell,
  FiCreditCard,
} from "react-icons/fi";
import { MdOutlineStorefront } from "react-icons/md";
import { MARKET } from "../../Routes/Marketplace/libs/marketplaceRoutes";

export const MERCHANT_NAV = [
  { to: "/merchant", label: "Overview", icon: FiHome, end: true },
  { to: "/merchant/products", label: "Products", icon: FiPackage },
  { to: "/merchant/inventory", label: "Inventory", icon: FiBox },
  { to: "/merchant/orders", label: "Orders", icon: FiShoppingBag },
  { to: "/merchant/payments", label: "Payments", icon: FiCreditCard },
  { to: "/merchant/analytics", label: "Analytics", icon: FiTrendingUp },
  { to: "/merchant/reviews", label: "Reviews", icon: FiStar },
  { to: "/merchant/store", label: "Store", icon: MdOutlineStorefront },
  { to: "/merchant/notifications", label: "Notifications", icon: FiBell },
  { to: "/merchant/account", label: "Account", icon: FiUser },
];

export const MERCHANT_FOOTER_LINKS = [
  { to: MARKET.HOME, label: "View marketplace", external: false },
];
